export const joinClassNames = (classNames: (string | undefined)[]): string => [...classNames].filter(Boolean).join(' ');
